import React, { useContext, useEffect, useState } from 'react';
import { Button, TextField, Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { TableBaseStyle } from './LoginStyle';

type LoginModeProps = {
  user: string;
  password: string;
  version: string;
  changeUserName: (userName: string) => void;
  changePassword: (userName: string) => void;
  startLoginAction: () => void;
};


const LoginMode: React.FC<LoginModeProps> = (props) => {
  const { t } = useTranslation();
  const classes = TableBaseStyle();

  return (
    <div className={classes.entryContainer}>
      <div style={{ height: '80px' }}></div>
      <div className={classes.entryRow}>
        <div className={classes.entryLabel}>{t('LoginMode.ユーザー名', 'ユーザー名')} </div>
        <TextField
          variant="outlined"
          size="small"
          className={classes.entry}
          value={props.user}
          onChange={(e) => props.changeUserName(e.target.value)}
          inputProps={{
            maxLength: 12,
          }}
        />
      </div>
      <div className={classes.entryRow}>
        <div className={classes.entryLabel}>{t('LoginMode.パスワード', 'パスワード')}</div>
        <TextField
          variant="outlined"
          size="small"
          type="password"
          className={classes.entry}
          value={props.password}
          onChange={(e) => props.changePassword(e.target.value)}
          onKeyPress={(e) => {
            if (e.key == 'Enter') {
              e.preventDefault();
              props.startLoginAction();
            }
          }}
          inputProps={{
            maxLength: 40,
          }}
        />
      </div>
      <div>
        <Button className={classes.loginButton} variant="outlined" onClick={(e) => props.startLoginAction()}>
          {t('LoginMode.ログイン', 'ログイン')}
        </Button>
      </div>
      <div className={classes.versionLabel}>{'version: ' + props.version}</div>
    </div>

  );
};

export default LoginMode;